module.exports = __webpack_public_path__ + "img/cloth_g1_hat_12.4fa9e68c.svg";